app.controller("AddSubjectToContainerController", [
    "$scope", "StaticData", "$uibModalInstance", "Subject", "params", "InfoModal", "toastr",
    function ($scope, StaticData, $uibModalInstance, Subject, params, InfoModal, toastr) {
        var containerId = params.containerId;
        var semesters = params.semesters;
        $scope.level = params.program ? params.program.level : null;
        $scope.savedParams = params.savedParams || null;
        $scope.semesters = _.range(1, semesters + 1);

        StaticData.getItemsByKey("subject_seasons").then(function (data) {
            $scope.seasons = data;
        });

        $scope.subjectList = null;
        $scope.season = null;
        $scope.semester = $scope.savedParams ? $scope.savedParams.semester : null;
        $scope.query = "";
        $scope.chosenSubject = null;
        $scope.newDependency = null;
        $scope.program = params.program;
        $scope.dep_id = "";
        $scope.dependencies = [];
        $scope.equals = null;
        $scope.preCredits = 0;
        $scope.credits = $scope.savedParams ? $scope.savedParams.credits : 5;

        $scope.changeSeason = function () {
            var value = $scope.semester;
            if (value) $scope.season = $scope.seasons[value % 2]
        };
        $scope.changeSeason();

        $scope.$watch('newDependency', function (val) {
            if (val && val._id) {
                $scope.dependencies.push(val);
                $scope.newDependency = null;
            }
        }, true);


        $scope.$watch('chosenSubject', function (val) {
            if (val && val._id) {
                $scope.credits = val.credits;
                $scope.name = val.name;
                for (var i in $scope.dependencies) {
                    var dep = $scope.dependencies[i];
                    if (val._id == dep._id) {
                        $scope.dependencies.splice(i, 1)
                    }
                }
                if (val.prerequisites) {
                    val.prerequisites.forEach(function (pr) {
                        return Subject.fetchOne(pr).then(function (data) {
                            $scope.dependencies.push(data.subject);
                        })
                    });
                }
            }
        }, true);

        $scope.delete_dependency = function (dep) {

            var el_index = _.findIndex($scope.dependencies, function (dependency) {
                return dependency._id === dep._id;
            });

            $scope.dependencies.splice(el_index, 1);
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query, level:$scope.level}).then(function (data) {
                return data.docs.filter(function (subj) {
                    var el_index = _.findIndex($scope.dependencies, function (dependency) {
                        return dependency._id === subj._id;
                    });

                    if ($scope.chosenSubject && $scope.chosenSubject._id === subj._id) {
                        return false;
                    }

                    return el_index === -1;
                })
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.create = function () {
            var prerequisites_list = $scope.dependencies.map(function (el) {
                return el._id
            });

            if (!$scope.chosenSubject || !$scope.chosenSubject._id) {
                return InfoModal.show({title: "შეცდომა", message: "მითითებული საგანი არ არსებობს!!! გთხოვთ სწორად მიუთითოთ საგნის სახელი."});
            }
            var subject = {
                subjectId: $scope.chosenSubject._id,
                name: $scope.name,
                lecturerId: "",
                containerId: containerId,
                season: $scope.season,
                semester: $scope.semester,
                program: $scope.program,
                credits: $scope.credits,
                preCredits: $scope.preCredits,
                prerequisites: prerequisites_list,
                equals: $scope.equals ? [$scope.equals._id] : []
            };
            toastr.success('', 'საგანი დამატებულია');
            params.method(subject).then(function () {
                $uibModalInstance.close(params)
            });
        };

        $scope.edit = function () {
            console.log('edit')
        }
    }
]);
